// web/src/auth.ts — client-side principal access + act-as identity (D-013).
// The server is the source of truth (GET /me); this is a typed convenience +
// the two-identity stub switcher mirroring the API stub (RUBRIC R5).

import type { Principal } from '../../shared/types';
import { api } from './api';

/** Shared act-as contract (both api.ts fetch + ws.ts query agree on these). */
export const ACT_AS_HEADER = 'X-BG-Act-As';
export const ACT_AS_QUERY = 'actAs';
const ACT_AS_KEY = 'bg-act-as';

export type ActAsId = 'rhys' | 'dana';

/** The two stub identities, mirrored from the API StubAuthProvider (D-013). */
export const STUB_PRINCIPALS: Record<ActAsId, Principal> = {
  rhys: {
    id: 'rhys',
    name: 'Rhys Evans',
    email: 'rhys@rhysevans.co.uk',
    role: 'admin',
  },
  dana: {
    id: 'dana',
    name: 'Dana Okoro',
    email: 'dana@planesailing.io',
    role: 'approver',
  },
};

/** Default identity per SPEC: Rhys Evans, admin. */
export const STUB_PRINCIPAL: Principal = STUB_PRINCIPALS.rhys;

let actAs: ActAsId = readActAs();

function readActAs(): ActAsId {
  try {
    return localStorage.getItem(ACT_AS_KEY) === 'dana' ? 'dana' : 'rhys';
  } catch {
    return 'rhys';
  }
}

/** Current act-as identity id, sent as the X-BG-Act-As header / actAs query. */
export function getActAs(): ActAsId {
  return actAs;
}

/** Switch the act-as identity and persist it. Callers re-fetch /me + reconnect. */
export function setActAs(id: ActAsId): void {
  actAs = id;
  try {
    localStorage.setItem(ACT_AS_KEY, id);
  } catch {
    // ignore storage failures (private mode); in-memory value still applies
  }
}

/** Fetch the authenticated principal from the API (honours the act-as header). */
export function fetchPrincipal(): Promise<Principal> {
  return api.me();
}
